/**
 * Extract a page-scoped text selection from the PDF text layer.
 *
 * The pdf.js text layer renders positioned spans inside per-page
 * `[data-page]` wrappers (see PdfViewer). Given the current DOM Selection and
 * the scroll container, this returns the selected text, its page number, and a
 * viewport rect for positioning a bubble, or null when there is no usable
 * selection inside the viewer.
 */
const MAX_QUOTE_LEN = 400;

export function getPdfSelectionInfo(selection, containerEl) {
  if (!selection || selection.isCollapsed || selection.rangeCount === 0) return null;
  if (!containerEl) return null;

  const range = selection.getRangeAt(0);
  const startNode = range.startContainer;
  const startEl =
    startNode.nodeType === Node.TEXT_NODE ? startNode.parentElement : startNode;
  if (!startEl || !containerEl.contains(startEl)) return null;

  const pageEl = startEl.closest('[data-page]');
  if (!pageEl) return null;
  const page = Number(pageEl.dataset.page);
  if (!page) return null;

  const text = selection.toString().trim();
  if (!text) return null;

  const rect = range.getBoundingClientRect();
  return {
    text: text.length > MAX_QUOTE_LEN ? `${text.slice(0, MAX_QUOTE_LEN)}…` : text,
    page,
    rect: {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      bottom: rect.bottom,
    },
  };
}
